import Vue from 'vue'
import globalDialog from './index.vue' 
let DialogConstrutor = Vue.extend(globalDialog)

let instance

const Dialog = function(options = {}) {
    //设置默认参数为对象，如果参数为字符串，参数中message属性等于该参数，回调函数为空
    //创建组件实例，data的数据回默认混合到组件实例里面
    instance = new DialogConstrutor({
        data: options
    })
    //将实例挂载到body下
    document.body.appendChild(instance.$mount().$el)
}

export default Dialog


// WEBPACK FOOTER //
// ./src/components/globalDialog/index.js